<div class="hardware-page">
  @if (
    currentRestaurant?.status === 'published' &&
    !currentRestaurant?.request_activation &&
    isFnfLikeProvider
  ) {
    <div class="sub-alert-banner sub-alert-banner--warning">
      <span class="sub-alert-icon"><i class="bx bx-info-circle"></i></span>
      <div class="sub-alert-text">
        <div class="sub-alert-title">Activation pending hardware integration</div>
        <div class="sub-alert-desc">
          If the hardware integration succeeds, our support team completes your restaurant's
          activation within 1-2 working days.
        </div>
      </div>
    </div>
  } @else if (currentRestaurant?.status === 'published' && currentRestaurant?.request_activation) {
    <div class="sub-alert-banner sub-alert-banner--warning">
      <span class="sub-alert-icon"><i class="bx bx-info-circle"></i></span>
      <div class="sub-alert-text">
        <div class="sub-alert-title">Activation request in progress</div>
        <div class="sub-alert-desc">
          Your activation request is in progress with {{ posProviderDisplayName }}. Our support team
          completes your restaurant's activation within 1-2 working days.
        </div>
      </div>
    </div>
  }
  <div class="hardware-card">
    <div class="card-heading">
      <span class="card-title">Hardware Integrations</span>
      <span class="card-subtitle">
        Fork & Find provides fully managed hardware solutions by default. If you prefer, you can
        switch to one of our partners, Clover, Square or Swirepay, to manage your hardware. Each
        integrates seamlessly with Fork & Find. Set them up here.
      </span>
    </div>

    <div class="provider-list">
      <!-- Fork & Find -->
      <div class="provider-row" [class.muted]="!isFnfLikeProvider">
        <span class="provider-logo">
          <img src="assets/forknfind.png" alt="Fork & Find" />
        </span>

        <div class="provider-text">
          <div class="provider-name-line">
            <span class="provider-name">Fork & Find</span>
            <!-- <span class="tag default">Default</span> -->
            @if (currentRestaurant?.pos_provider === 'fnf') {
              <span class="tag active">Active</span>
            }
          </div>
          <span class="provider-desc">
            Fork & Find Hardware is our fully integrated setup, designed to work seamlessly with the
            platform.
          </span>
        </div>

        @if (!currentRestaurant?.request_activation) {
          <div class="provider-actions">
            <button type="button" class="connect-btn primary" (click)="enableFnf()">
              Enable Fork & Find
            </button>
          </div>
        }
      </div>

      <!-- Clover -->
      @if (isShowCloverCard) {
        <div class="provider-row" [class.muted]="currentRestaurant?.pos_provider !== 'clover'">
          <span class="provider-logo">
            <img src="assets/clover.png" alt="Clover" />
          </span>

          <div class="provider-text">
            <div class="provider-name-line">
              <span class="provider-name">Clover</span>
              @if (currentRestaurant?.pos_provider === 'clover') {
                <span class="tag active">Active</span>
              }
            </div>
            <span class="provider-desc">
              Clover POS provides reliable hardware and flexible tools for handling payments, sales,
              and everyday restaurant operations.
            </span>
          </div>

          <div class="provider-actions">
            @if (currentRestaurant?.pos_provider !== 'clover') {
              <button
                type="button"
                class="connect-btn primary"
                (click)="getCloverAuthorizationDetails()"
              >
                Enable Clover
              </button>
            } @else {
              <button
                type="button"
                class="connect-btn"
                (click)="getCloverAuthorizationDetails()"
                aria-label="Refresh Square connection"
              >
                Reconnect
              </button>
            }
          </div>
        </div>
      }

      <!-- Square -->
      @if (isShowSquareCard) {
        <div class="provider-row" [class.muted]="currentRestaurant?.pos_provider !== 'square'">
          <span class="provider-logo">
            <img src="assets/square.webp" alt="Square" />
          </span>

          <div class="provider-text">
            <div class="provider-name-line">
              <span class="provider-name">Square</span>
              @if (
                currentRestaurant?.pos_provider === 'square' && squareOnboardStatus == 'completed'
              ) {
                <span class="tag active">Active</span>
              } @else if (
                currentRestaurant?.pos_provider === 'square' &&
                squareOnboardStatus == 'auth_expired'
              ) {
                <span class="tag text-white bg-danger">Expired</span>
              } @else if (
                currentRestaurant?.pos_provider === 'square' && squareOnboardStatus == 'revoked'
              ) {
                <span class="tag text-white bg-warning">Revoked</span>
              } @else if (
                currentRestaurant?.pos_provider === 'square' && squareOnboardStatus == 'not_defined'
              ) {
                <span class="tag text-white bg-danger">Disconnected</span>
              } @else if (
                currentRestaurant?.pos_provider === 'square' && squareOnboardStatus == 'failed'
              ) {
                <span class="tag text-white bg-danger">Sync Failed</span>
              }
            </div>
            <span class="provider-desc">
              Square provides integrated payment processing and POS hardware to manage payments,
              orders, and restaurant operations.
            </span>
            @if (currentRestaurant?.pos_provider === 'square') {
              <div class="provider-meta">
                @if (squareLocationName) {
                  <span class="provider-meta-item">
                    <i class="bx bx-map-pin"></i>
                    {{ squareLocationName }}
                  </span>
                }
                @if (squareMenuNames) {
                  <span class="provider-meta-item ml-5">
                    <i class="bx bx-food-menu"></i>
                    {{ squareMenuNames }}
                  </span>
                }
              </div>
            }
          </div>

          <div class="provider-actions">
            @if (currentRestaurant?.pos_provider !== 'square') {
              <button
                type="button"
                class="connect-btn primary"
                (click)="getSquareAuthorizationDetails()"
              >
                Enable Square
              </button>
            } @else {
              @if (!(squareOnboardStatus == 'not_defined' || squareOnboardStatus == 'revoked')) {
                <button
                  type="button"
                  class="btn btn-outline-danger p-2"
                  (click)="disconnectConfirmation()"
                  aria-label="Disconnect Square connection"
                >
                  Disconnect
                </button>
              }
              <button
                type="button"
                class="connect-btn"
                (click)="getSquareAuthorizationDetails()"
                aria-label="Refresh Square connection"
              >
                Reconnect
              </button>
            }
          </div>
        </div>
      }

      <!-- Swirepay -->
      @if (isShowSwirepayCard) {
        <div class="provider-row" [class.muted]="!isSwirepayProvider">
          <span class="provider-logo">
            <img src="assets/swirepay.png" alt="Swirepay" />
          </span>

          <div class="provider-text">
            <div class="provider-name-line">
              <span class="provider-name">Swirepay</span>
              @if (isSwirepayProvider && swirepayOnboardStatus == 'completed') {
                <span class="tag active">Active</span>
              } @else if (isSwirepayProvider && swirepayOnboardStatus == 'in_progress') {
                <span class="tag text-white bg-warning">Syncing</span>
              } @else if (isSwirepayProvider && swirepayOnboardStatus == 'failed') {
                <span class="tag text-white bg-danger">Sync Failed</span>
              } @else if (isSwirepayProvider && swirepayOnboardStatus == 'not_connected') {
                <span class="tag text-white bg-danger">Disconnected</span>
              }
            </div>
            <span class="provider-desc">
              Swirepay runs your Clover hardware and payments. Connect your Swirepay merchant
              account to sync your menu and receive Fork & Find orders.
            </span>
            @if (isSwirepayProvider && swirepayStatus?.shop_name) {
              <div class="provider-meta">
                <span class="provider-meta-item">
                  <i class="bx bx-store"></i>
                  {{ swirepayStatus.shop_name }}
                </span>
              </div>
            }
          </div>

          <div class="provider-actions">
            @if (!isSwirepayProvider) {
              <button type="button" class="connect-btn primary" (click)="enableSwirepay()">
                Enable Swirepay
              </button>
            } @else {
              @if (swirepayOnboardStatus != 'not_connected') {
                <button
                  type="button"
                  class="btn btn-outline-danger p-2"
                  (click)="disconnectSwirepayConfirmation()"
                  aria-label="Disconnect Swirepay connection"
                >
                  Disconnect
                </button>
              }
              <button
                type="button"
                class="connect-btn"
                (click)="enableSwirepay()"
                aria-label="Reconnect Swirepay"
              >
                Reconnect
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
